import { CircularProgress } from "@mui/material";
import MuiButton from "@mui/material/Button";
import React, { MouseEvent } from "react";
import styles from "./styles";

interface Props {
  label: string;
  type?: "button" | "submit" | "reset";
  color?: "inherit" | "primary" | "secondary";
  onClick?(event: MouseEvent<HTMLElement>): void;
  onSubmit?: any;
  icon?: JSX.Element;
  size?: "small" | "medium" | "large";
  variant?: "text" | "outlined" | "contained";
  fetching?: boolean;
  style?: any;
  className?: string;
}

/**
 * Composant affichant un bouton.
 */
const Button = (props: Props) => {
  const {
    color,
    icon,
    label,
    onClick,
    size,
    type,
    variant,
    fetching,
    onSubmit,
    style,
  } = props;

  let className = "root";

  if (icon) {
    className += " iconButton";
  }
  if (fetching) {
    return <CircularProgress />;
  }
  return (
    <MuiButton
      sx={styles}
      type={type || "button"}
      color={color}
      variant={variant || "contained"}
      onClick={onClick}
      onSubmit={onSubmit}
      size={size || "large"}
      className={className + " " + props.className}
      classes={{
        root: "root",
        containedPrimary: "containedPrimary",
        textInherit: "textInherit",
        sizeSmall: "sizeSmall",
      }}
      style={style}
    >
      {icon && color === "inherit" && (
        <span className={"icon prevIcon"}>{icon}</span>
      )}
      {label}
      {icon && color !== "inherit" && (
        <span className={"icon nextIcon"}>{icon}</span>
      )}
    </MuiButton>
  );
};

export default Button;
